import Route from '@ember/routing/route';

export default class CoachingConfigsRoute extends Route {}
